import { BreadCrumb } from '../../components/Breadcrumb/BreadCrumb'
import React, { useEffect } from 'react'
import { Box } from '@mui/material'
import { Outlet, useLocation } from 'react-router-dom'
import NavMenu from './component/NavMenu/NavMenu'
import LogoutButton from './component/LogoutButton/LogoutButton'
import { useAppDispatch, useAppSelector } from '../../store/utils/hooks'
import { actionUpdateUserData, selectUserData } from '../../store/slices/user/userSlice'

export default function AccountSettingsPage() {
	const dispatch = useAppDispatch()
	const location = useLocation()
	const { data: user } = useAppSelector(selectUserData)

	useEffect(() => {
		return () => {
			dispatch(actionUpdateUserData(user.user_id))
		}
	}, [dispatch, location, user.user_id])

	return (
		<Box sx={{ width: '100%' }}>
			<Box mb="20px" display="flex" justifyContent="space-between" alignItems="center">
				<BreadCrumb pathname="/settings" />
				<LogoutButton />
			</Box>
			<Box sx={{ paddingLeft: '48px' }}>
				<NavMenu />
			</Box>
			<Box justifyContent="space-between" alignItems="center" display="flex" flexDirection="column" width="100%">
				<Outlet />
			</Box>
		</Box>
	)
}
